import data from './data'
import methods from './methods'
import components from './components'
import mounted from './mounted'
import validations from './validations'

export default {
  data,
  methods,
  mounted,
  components,
  validations,
  /* route API for professional covenants */
  resourcePath: '/v1/professional/companies/covenants'
}



// WEBPACK FOOTER //
// ./src/app/professional/company/covenants/resources/index.js